import React, { useEffect, useState } from "react";
/** @jsxImportSource @emotion/react */
import tw, { styled } from "twin.macro";
import { LandingLayout } from "../../components";
import {
	btnStyle,
	inputStyle,
	LandingTitle,
} from "../../lib/styles/styleLibrary";
import lock from "../../assets/svg/lock.svg";
import { Input } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useHistory, useLocation } from "react-router";
// import { isEmpty } from "../../lib/helpers/helpers";

const Wrapper = styled.div`
	${tw`sm:p-8! md:p-16! sm:max-w-md sm:mx-auto md:max-w-none md:mx-0`}

	@media (min-width: 769px) and (max-width: 1023px) {
		padding: 16px !important;
	}
`;

const NewPassword = (props) => {
	const history = useHistory();
	const location = useLocation();
	const searchParams = new URLSearchParams(location.search);
	const email = searchParams.get("email");
	const code = searchParams.get("code");

	const [fields, setField] = useState({
		email: email,
		code: code,
		new_password: "",
	});
	useEffect(() => {
		setField({ ...fields, email, code });
	}, [email, code, fields]);
	console.log(fields);
	return (
		<LandingLayout>
			<div tw="h-full flex! flex-col!">
				<Wrapper>
					<ArrowLeftOutlined
						tw="p-3 bg-gray-100 mb-12 rounded-full hover:bg-white"
						onClick={() => history.goBack()}
					/>

					<LandingTitle>
						New <br />
						Password
					</LandingTitle>

					<div tw="pt-8">
						<p tw="text-lg">
							Please enter a new password for <br />
							<b>{email ?? "your email"}</b>, then sign in
						</p>
					</div>

					<div tw="w-full">
						<form tw="flex flex-col sm:w-full md:w-full xl:w-8/12 lg:w-9/12">
							<Input.Password
								placeholder="Your password"
								type="password"
								css={inputStyle}
								prefix={
									<img
										src={lock}
										alt=""
										tw=" focus:opacity-100 hover:opacity-100 pr-2"
									/>
								}
							/>

							<Input.Password
								placeholder="Confirm password"
								type="password"
								css={inputStyle}
								prefix={
									<img
										src={lock}
										alt=""
										tw=" focus:opacity-100 hover:opacity-100 pr-2"
									/>
								}
							/>

							<button css={btnStyle}>Send</button>
						</form>
					</div>
				</Wrapper>{" "}
			</div>
		</LandingLayout>
	);
};

export default NewPassword;
